// extracted by css-extract-rspack-plugin
export default {"listContainer":"OrganisationTypeList_listContainer__haIXQ"};